module.exports = __webpack_public_path__ + "media/images/emblems/Essertines-sur-Yverdon-coat_of_arms-256bfcc98eb89db0628dde91a45ba7c6.svg";